import style from './PreAppPage.module.scss'
import logo from '../../../assets/imgs/logo/el_gran_kush/lg_wht_png.png'
import { NavLink } from 'react-router-dom'




const PreAppPage = (props) => {

    let link = props.isStart ? './contacts' : '../'
    let linkTitle = props.isStart ? 'Our contacts' : 'Back to start'
    return (

        <div className={style.start__page}

        >
           
            <div className={style.wrapper} >
                <div className={style.logo__wrapper}>
                
                    <img className={style.logo} src={logo} alt='img-logo' />
                    <h1 className={style.name}>El Gran Kush</h1>
              
                </div>
                <div className={style.content}>
                    {props.children}

                </div>



                <div className={style.start__policy}>
                    <p className={style.policy__text}>© 2023 El Gran Kush. All rights reserved
                        <NavLink className={style.toContacts} to={link}>
                            {linkTitle}
                        </NavLink>
                    </p>
                </div>


            </div>


        </div>


    )
}


export default PreAppPage